import { render, staticRenderFns } from "./mailingArea.vue?vue&type=template&id=0f6b217e&scoped=true"
import script from "./mailingArea.vue?vue&type=script&lang=js"
export * from "./mailingArea.vue?vue&type=script&lang=js"
import style0 from "./mailingArea.vue?vue&type=style&index=0&id=0f6b217e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b217e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6b217e')) {
      api.createRecord('0f6b217e', component.options)
    } else {
      api.reload('0f6b217e', component.options)
    }
    module.hot.accept("./mailingArea.vue?vue&type=template&id=0f6b217e&scoped=true", function () {
      api.rerender('0f6b217e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Finance/mailingArea.vue"
export default component.exports